/**
 * Checks if the browser supports requestIdleCallback
 */
export function isIdleCallbackEnabled() {
  return !!window.requestIdleCallback;
}

/**
 * Excel has monkey patched their requestIdleCallbacks to take in an optional callbackName and callerName parameters at the end.
 * This helps add telemetry to track long request idle callbacks.
 *
 * For other apps, that argument will be ignored.
 *
 * Note that this type is very primitive. The return type of requestIdleCallback is void while it returns a cancellable id.
 * If you want to extend it, please see https://github.com/Microsoft/TypeScript/issues/21309#issuecomment-376338415 for reference.
 */
declare global {
  interface Window {
    // @ts-ignore Bug:5821196 - [TS 4.5.2 upgrade OOUI] Fix requestIdleCallback across OOUI
    requestIdleCallback: (
      cb: () => void,
      options?: { timeout: number },
      callbackName?: string,
      callerName?: string
    ) => void;
  }
}
